const RUNTIME = window.__APP_CONFIG__ || {};

export const CONFIG = {
  API_URL: RUNTIME.API_URL || process.env.REACT_APP_BACKEND || "https://api-test.bjjlevice.sk"
}